export function friendlyCrmSyncError(raw: string | null | undefined): string {
  const text = (raw ?? "").trim();
  if (!text) return "We couldn't sync this record to your CRM.";
  const t = text.toLowerCase();
  if (/\b409\b|duplicate|conflict/.test(t)) {
    return "Your CRM already has a matching record, so we couldn't create another. Merge or remove the duplicate in your CRM, then retry.";
  }
  if (/\b(401|403)\b|unauthori[sz]ed|forbidden|token|credential/.test(t)) {
    return "Your CRM connection has expired or lacks permission. Reconnect it in Integrations, then retry.";
  }
  if (/\b429\b|rate.?limit|too many/.test(t)) {
    return "Your CRM is limiting requests right now. Wait a few minutes, then retry.";
  }
  if (/\b(400|422)\b|invalid|validation|bad request/.test(t)) {
    return "Your CRM rejected some of this record's details. Check the fields (such as phone and email) and retry.";
  }
  if (/\b5\d\d\b|timeout|timed out|unavailable|connect/.test(t)) {
    return "We couldn't reach your CRM. Try again in a few minutes.";
  }
  return "We couldn't sync this record to your CRM. Retry, and contact support if it keeps failing.";
}
